/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';

/**
 * 
 * @export
 * @interface LeaveAllowanceChunk
 */
export interface LeaveAllowanceChunk {
    /**
     * 
     * @type {number}
     * @memberof LeaveAllowanceChunk
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof LeaveAllowanceChunk
     */
    leaveRequestId: number;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof LeaveAllowanceChunk
     */
    date: ShiftiePlainDate;
    /**
     * 
     * @type {number}
     * @memberof LeaveAllowanceChunk
     */
    allowanceUsedInDays: number;
    /**
     * 
     * @type {number}
     * @memberof LeaveAllowanceChunk
     */
    allowanceUsedInHours: number;
    /**
     * 
     * @type {number}
     * @memberof LeaveAllowanceChunk
     */
    paidHours: number;
    /**
     * 
     * @type {number}
     * @memberof LeaveAllowanceChunk
     */
    basePayRate: number;
    /**
     * 
     * @type {Date}
     * @memberof LeaveAllowanceChunk
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof LeaveAllowanceChunk
     */
    updatedAt: Date | null;
}

/**
 * Check if a given object implements the LeaveAllowanceChunk interface.
 */
export function instanceOfLeaveAllowanceChunk(value: object): value is LeaveAllowanceChunk {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('leaveRequestId' in value) || value['leaveRequestId'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('allowanceUsedInDays' in value) || value['allowanceUsedInDays'] === undefined) return false;
    if (!('allowanceUsedInHours' in value) || value['allowanceUsedInHours'] === undefined) return false;
    if (!('paidHours' in value) || value['paidHours'] === undefined) return false;
    if (!('basePayRate' in value) || value['basePayRate'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function LeaveAllowanceChunkFromJSON(json: any): LeaveAllowanceChunk {
    return LeaveAllowanceChunkFromJSONTyped(json, false);
}

export function LeaveAllowanceChunkFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaveAllowanceChunk {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'leaveRequestId': json['leaveRequestId'],
        'date': ShiftiePlainDateFromJSON(json['date']),
        'allowanceUsedInDays': json['allowanceUsedInDays'],
        'allowanceUsedInHours': json['allowanceUsedInHours'],
        'paidHours': json['paidHours'],
        'basePayRate': json['basePayRate'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
    };
}

  export function LeaveAllowanceChunkToJSON(json: any): LeaveAllowanceChunk {
      return LeaveAllowanceChunkToJSONTyped(json, false);
  }

  export function LeaveAllowanceChunkToJSONTyped(value?: LeaveAllowanceChunk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'leaveRequestId': value['leaveRequestId'],
        'date': ShiftiePlainDateToJSON(value['date']),
        'allowanceUsedInDays': value['allowanceUsedInDays'],
        'allowanceUsedInHours': value['allowanceUsedInHours'],
        'paidHours': value['paidHours'],
        'basePayRate': value['basePayRate'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': (value['updatedAt'] == null ? null : (value['updatedAt'] as any).toISOString()),
    };
}

